import { render } from "./agendahero.vue?vue&type=template&id=59b7f5f2&scoped=true"
import script from "./agendahero.vue?vue&type=script&lang=js"
export * from "./agendahero.vue?vue&type=script&lang=js"

import "./agendahero.vue?vue&type=style&index=0&id=59b7f5f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59b7f5f2"

export default script